import React from "react";
import ReactDom from "react-dom";
import "./app.css";
import  Myapp  from "./app";


ReactDom.render(
    
    <>
         <Myapp/>
         
    </>
    
,document.getElementById('root'));